
(function () {
  'use strict';

  const STORAGE_KEY = 'skyline_compare_products';
  const BAR_VISIBLE_KEY = 'skyline_compare_bar_visible';
  const MAX_PRODUCTS = 4;
  const MIN_PRODUCTS = 2;
  const COMPARE_PAGE_URL = '/pages/compare';

  const compareBar = document.getElementById('compare-bar');
  const compareProducts = document.getElementById('compare-bar-products');
  const compareCount = document.getElementById('compare-count');
  const compareOpen = document.getElementById('compare-open');
  const compareClear = document.getElementById('compare-clear');
  const floatingOpen = document.getElementById('compare-floating-open');
  const floatingClose = document.getElementById('compare-floating-close');
  const floatingCount = document.getElementById('compare-floating-count');

  let stickyObserver = null;
  let bodyObserver = null;
  let stickyAtc = null;

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function getSelected() {
    try {
      const products = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  }

  function saveSelected(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      console.error('Unable to save comparison products:', error);
    }
  }

  function cleanSelected(products) {
    const seen = new Set();

    return products.filter(function (product) {
      if (!product || !product.handle || seen.has(product.handle)) return false;
      seen.add(product.handle);
      return true;
    }).slice(0, MAX_PRODUCTS);
  }

  function setCompareBarVisible(visible) {
    try {
      if (visible) {
        sessionStorage.setItem(BAR_VISIBLE_KEY, 'true');
      } else {
        sessionStorage.removeItem(BAR_VISIBLE_KEY);
      }
    } catch (error) {}
  }

  function isCompareBarVisible() {
    try {
      return sessionStorage.getItem(BAR_VISIBLE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function getStickyAtc() {
    return document.querySelector('.sticky-atc');
  }

  function isStickyAtcVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      !element.classList.contains('hidden') &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity) > 0 &&
      rect.height > 0 &&
      rect.width > 0 &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    );
  }

  function updateStickyAtcState() {
    const element = getStickyAtc();
    const visible = isStickyAtcVisible(element);

    document.body.classList.toggle('sticky-atc-visible', visible);

    if (element) {
      const height = Math.ceil(element.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--sticky-atc-height', height + 'px');
    }

    if (compareBar) {
      compareBar.classList.toggle('compare-sticky-atc-active', visible);
    }
  }

  function syncCheckboxes() {
    const selected = cleanSelected(getSelected());

    document.querySelectorAll('.compare-checkbox-input').forEach(function (checkbox) {
      const handle = checkbox.dataset.compareHandle;
      const checked = selected.some(function (product) {
        return product.handle === handle;
      });

      checkbox.checked = checked;
      checkbox.disabled = selected.length >= MAX_PRODUCTS && !checked;
    });
  }

  function renderBar() {
    if (!compareBar) {
      syncCheckboxes();
      return;
    }

    const selected = cleanSelected(getSelected());
    saveSelected(selected);

    const count = selected.length;

    if (compareCount) {
      compareCount.textContent = count + ' / ' + MAX_PRODUCTS;
    }

    if (floatingCount) {
      floatingCount.textContent = count;
    }

    if (compareProducts) {
      compareProducts.innerHTML = '';

      selected.forEach(function (product) {
        const item = document.createElement('div');
        item.className = 'compare-bar__thumb';
        item.dataset.handle = product.handle;

        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title || '';
          image.loading = 'lazy';
          item.appendChild(image);
        }

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'compare-bar__thumb-remove';
        removeButton.dataset.compareRemove = product.handle;
        removeButton.setAttribute('aria-label', 'Remove ' + (product.title || 'product'));
        removeButton.innerHTML = '&times;';
        item.appendChild(removeButton);

        compareProducts.appendChild(item);
      });
    }

    if (compareOpen) {
      compareOpen.disabled = count < MIN_PRODUCTS;
    }

       if (count === 0) {
      setCompareBarVisible(false);
      compareBar.classList.remove('is-visible', 'compare-bar--expanded');
      compareBar.classList.add('compare-bar--collapsed');
      compareBar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('compare-bar-active');
    } else {
      updateStickyAtcState();

      const showFloatingButton = isProductPage() &&
        document.body.classList.contains('sticky-atc-visible');

      if (showFloatingButton) {
        compareBar.classList.add('is-visible', 'compare-bar--collapsed');
        compareBar.classList.remove('compare-bar--expanded');
        compareBar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('compare-bar-active');
      } else if (isCompareBarVisible()) {
        compareBar.classList.add('is-visible');
        compareBar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('compare-bar-active');
      } else {
        compareBar.classList.remove('is-visible', 'compare-bar--expanded');
        compareBar.classList.add('compare-bar--collapsed');
        compareBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('compare-bar-active');
      }
    }

    syncCheckboxes();
    updateStickyAtcState();
  }

  function getProductFromCheckbox(checkbox) {
    return {
      handle: checkbox.dataset.compareHandle || '',
      title: checkbox.dataset.compareTitle || '',
      url: checkbox.dataset.compareUrl || '',
      image: checkbox.dataset.compareImage || '',
      brand: checkbox.dataset.compareBrand || '',
      price: checkbox.dataset.comparePrice || '',
      size: checkbox.dataset.compareSize || '',
      color: checkbox.dataset.compareColor || '',
      application: checkbox.dataset.compareApplication || '',
      capacity: checkbox.dataset.compareCapacity || '',
      material: checkbox.dataset.compareMaterial || '',
      attachment: checkbox.dataset.compareAttachment || '',
      sinkAccessories: checkbox.dataset.compareSinkAccessories || '',
      compatibleTools: checkbox.dataset.compareCompatibleTools || '',
      sinkShape: checkbox.dataset.compareSinkShape || '',
      sinkRadius: checkbox.dataset.compareSinkRadius || '',
      sinkGauge: checkbox.dataset.compareSinkGauge || '',
      sinkMaterial: checkbox.dataset.compareSinkMaterial || '',
      sinkType: checkbox.dataset.compareSinkType || ''
    };
  }

  function addProduct(checkbox) {
    const product = getProductFromCheckbox(checkbox);
    if (!product.handle) return;

    let selected = cleanSelected(getSelected());

    if (selected.some(function (item) {
      return item.handle === product.handle;
    })) {
      renderBar();
      return;
    }

    if (selected.length >= MAX_PRODUCTS) {
      checkbox.checked = false;
      syncCheckboxes();
      return;
    }

    selected.push(product);
    saveSelected(selected);
    setCompareBarVisible(true);
    renderBar();
  }

  function removeProduct(handle) {
    if (!handle) return;

    const selected = getSelected().filter(function (product) {
      return product.handle !== handle;
    });

    saveSelected(selected);

    if (selected.length === 0) {
      setCompareBarVisible(false);
    }

    renderBar();
  }

  function clearAll() {
    saveSelected([]);
    setCompareBarVisible(false);

    document.querySelectorAll('.compare-checkbox-input').forEach(function (checkbox) {
      checkbox.checked = false;
      checkbox.disabled = false;
    });

    if (compareBar) {
      compareBar.classList.remove('is-visible', 'compare-bar--expanded');
      compareBar.classList.add('compare-bar--collapsed');
      compareBar.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('compare-bar-active');
    renderBar();
  }

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('.compare-checkbox-input');
    if (!checkbox) return;

    if (checkbox.checked) {
      const selected = cleanSelected(getSelected());

      if (selected.length >= MAX_PRODUCTS) {
        checkbox.checked = false;
        syncCheckboxes();
        return;
      }

      addProduct(checkbox);
    } else {
      removeProduct(checkbox.dataset.compareHandle);
    }
  });

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('[data-compare-remove]');

    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      removeProduct(removeButton.dataset.compareRemove);
      return;
    }

    const wrapper = event.target.closest('.compare-checkbox-wrapper');
    if (wrapper) event.stopPropagation();
  }, true);

  if (compareClear) {
    compareClear.addEventListener('click', clearAll);
  }

  if (compareOpen) {
    compareOpen.addEventListener('click', function () {
      if (cleanSelected(getSelected()).length < MIN_PRODUCTS) return;
      window.location.href = COMPARE_PAGE_URL;
    });
  }

  if (floatingOpen) {
    floatingOpen.addEventListener('click', function () {
      if (!compareBar || !getSelected().length) return;

      setCompareBarVisible(true);
      compareBar.classList.add('is-visible', 'compare-bar--expanded');
      compareBar.classList.remove('compare-bar--collapsed');
      compareBar.setAttribute('aria-hidden', 'false');
      document.body.classList.add('compare-bar-active');
      renderBar();
    });
  }

  if (floatingClose) {
    floatingClose.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (!compareBar) return;

      compareBar.classList.remove('compare-bar--expanded');
      compareBar.classList.add('compare-bar--collapsed');
      compareBar.setAttribute('aria-hidden', 'false');
    });
  }

  function watchStickyAtc() {
    function observeStickyAtc(element) {
      if (!element || element === stickyAtc) return;

      if (stickyObserver) stickyObserver.disconnect();

      stickyAtc = element;
      stickyObserver = new MutationObserver(updateStickyAtcState);

      stickyObserver.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });

      updateStickyAtcState();
    }

    observeStickyAtc(getStickyAtc());

    if (bodyObserver) bodyObserver.disconnect();

    bodyObserver = new MutationObserver(function () {
      const element = getStickyAtc();

      if (element !== stickyAtc) {
        observeStickyAtc(element);
      }

      updateStickyAtcState();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', updateStickyAtcState, { passive: true });
    window.addEventListener('resize', updateStickyAtcState);
  }

  function initCompare() {
    // Keep saved selections, but start each page load with the bar hidden.
    setCompareBarVisible(false);

    if (compareBar) {
      compareBar.classList.remove('is-visible', 'compare-bar--expanded');
      compareBar.classList.add('compare-bar--collapsed');
      compareBar.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('compare-bar-active');

    syncCheckboxes();
    renderBar();
    watchStickyAtc();
  }

  window.addEventListener('pageshow', function () {
    syncCheckboxes();
    updateStickyAtcState();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) renderBar();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompare);
  } else {
    initCompare();
  }
})();
